var exhOnBalanceNYC_1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_1.jpg';
var exhOnBalanceNYC_2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_2.jpg';
var exhOnBalanceNYC_3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_3.jpg';
var exhOnBalanceNYC_4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_4.jpg';
var exhOnBalanceNYC_5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_5.jpg';
var exhOnBalanceNYC_6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_6.jpg';
var exhOnBalanceNYC_7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_7.jpg';
var exhOnBalanceNYC_8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_8.jpg';
var exhOnBalanceNYC_9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_9.jpg';
var exhOnBalanceNYC_10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_10.jpg';
var exhOnBalanceNYC_11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_11.jpg';
var exhOnBalanceNYC_12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_12.jpg';
var exhOnBalanceNYC_13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_13.jpg';
var exhOnBalanceNYC_14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_14.jpg';
var exhOnBalanceNYC_15 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_15.jpg';
var exhOnBalanceNYC_16 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_16.jpg';
var exhOnBalanceNYC_17 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_17.jpg';
var exhOnBalanceNYC_18 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_18.jpg';
var exhOnBalanceNYC_19 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_19.jpg';
var exhOnBalanceNYC_20 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_20.jpg';
var exhOnBalanceNYC_21 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_21.jpg';
var exhOnBalanceNYC_22 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_22.jpg';
var exhOnBalanceNYC_23 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_23.jpg';
var exhOnBalanceNYC_24 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_onbalance_nyc/exhOnBalanceNYC_24.jpg';

export const allImagesDesktopOrderExhOnBalanceNYC = [
    [/*COLUMN 1*/
        [
            {
                name: exhOnBalanceNYC_1,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc1"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_2,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc2"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_3,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc3"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_4,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc4"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_5,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc5"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_6,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc6"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_7,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc7"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_8,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc8"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhOnBalanceNYC_9,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc9"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_10,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc10"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_11,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc11"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_12,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc12"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_13,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc13"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_14,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc14"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_15,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc14"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_16,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc14"
            },
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhOnBalanceNYC_17,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc17"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_18,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc18"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_19,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc19"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_20,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc20"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_21,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc21"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_22,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc22"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_23,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc23"
            },
        ],
        [
            {
                name: exhOnBalanceNYC_24,
                captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
                captionln2: "",
                captionln3: "",
                link: "onbalance_nyc24"
            },
        ]
    ]          
]

export const allImagesMobileOrderExhOnBalanceNYC = [
    [{
        name: exhOnBalanceNYC_1,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc1"
    },
    {
        name: exhOnBalanceNYC_2,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc2"
    },
    {
        name: exhOnBalanceNYC_3,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc3"
    },
    {
        name: exhOnBalanceNYC_4,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc4"
    },
    {
        name: exhOnBalanceNYC_5,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc5"
    },
    {
        name: exhOnBalanceNYC_6,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc6"
    },
    {
        name: exhOnBalanceNYC_7,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc7"
    },
    {
        name: exhOnBalanceNYC_8,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc8"
    },
    {
        name: exhOnBalanceNYC_9,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc9"
    },
    {
        name: exhOnBalanceNYC_10,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc10"
    },
    {
        name: exhOnBalanceNYC_11,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc11"
    },
    {
        name: exhOnBalanceNYC_12,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc12"
    },
    {
        name: exhOnBalanceNYC_13,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc13"
    },
    {
        name: exhOnBalanceNYC_14,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc14"
    },
    {
        name: exhOnBalanceNYC_15,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc14"
    },
    {
        name: exhOnBalanceNYC_16,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc14"
    },
    {
        name: exhOnBalanceNYC_17,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc17"
    },
    {
        name: exhOnBalanceNYC_18,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc18"
    },
    {
        name: exhOnBalanceNYC_19,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc19"
    },
    {
        name: exhOnBalanceNYC_20,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc20"
    },
    {
        name: exhOnBalanceNYC_21,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc21"
    },
    {
        name: exhOnBalanceNYC_22,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc22"
    },
    {
        name: exhOnBalanceNYC_23,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc23"
    },
    {
        name: exhOnBalanceNYC_24,
        captionln1: "<b>On Balance</b> solo exhibition at Gerald Peters Gallery in New York City",
        captionln2: "",
        captionln3: "",
        link: "onbalance_nyc24"
    }]      
]
